<template>
  <div class="d-inline pull-left">
    <b-modal
      id="edit-warehouse-modal"
      ref="edit-warehouse-modal"
      size="lg"
      @ok="saveWarehouse"
      @shown="initializeModal"
      :ok-title="isSaving ? 'Saving...' : 'Save'"
      :ok-disabled="isSaving"
      scrollable
    >
      <template slot="modal-header">
        <h5 class="modal-title">{{ modalTitle }}</h5>
      </template>

      <form
        id="edit-warehouse"
        class="warehouse--edit-warehouse"
      >
        <b-container>
          <b-row>
            <b-col cols="6">
              <b-form-group class="required" label="Name">
                <b-form-input
                  id="warehouse-name-input"
                  class="form-input"
                  :class="{ 'is-invalid': $v.warehouse.name.$error }"
                  v-model="warehouse.name"
                  @blur="$v.warehouse.name.$touch()"
                ></b-form-input>
                <div class="invalid-feedback">
                  <div v-if="!$v.warehouse.name.required">Name is required</div>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group v-if="this.id" label="Activity">
                <b-form-checkbox v-model="warehouse.active">
                  Active
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Address Line 1">
                <b-form-input
                  id="address1-input"
                  class="form-input"
                  v-model="warehouse.address1"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Address Line 2">
                <b-form-input
                  id="address2-input"
                  class="form-input"
                  v-model="warehouse.address2"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Address Line 3">
                <b-form-input
                  id="address3-input"
                  class="form-input"
                  v-model="warehouse.address3"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="City">
                <b-form-input
                  id="city-input"
                  class="form-input"
                  v-model="warehouse.city"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <b-form-group label="State/Province">
                <b-form-input
                  id="state-input"
                  class="form-input"
                  v-model="warehouse.state"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Postal Code">
                <b-form-input
                  id="zip-code-input"
                  class="form-input"
                  v-model="warehouse.zipCode"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Phone">
                <b-form-input
                  id="phone-input"
                  class="form-input"
                  v-model="warehouse.phone"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <required-descriptor />
        </b-container>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';

import warehouseService from '../../service';
import WarehouseInfoDto from './dto';

export default {
  props: ['id'],
  data() {
    return {
      warehouse: {
        id: 0,
        name: '',
      },
      isSaving: false,
    }
  },
  computed: {
    modalTitle: function() {
      if (this.id) {
        return 'Edit Warehouse';
      } else {
        return 'Add New Warehouse';
      }
    },
    actualEditId: function() {
      return this.id;
    },
  },
  validations: {
    warehouse: {
      name: { required },
    },
  },
  methods: {
    ...mapActions('warehouse', ['getWarehouses']),
    async initializeModal() {
      this.$v.warehouse.$reset();
      if (this.actualEditId) {
        this.warehouse = await warehouseService.getById(this.actualEditId);
      } else {
        this.warehouse = new WarehouseInfoDto();
      }
    },
    saveWarehouse: async function(e) {
      this.$v.warehouse.$touch();
      if (this.$v.warehouse.$invalid) {
        e.preventDefault();
        return;
      }

      const data = new WarehouseInfoDto(this.warehouse);
      try {
        this.isSaving = true;
        if (this.warehouse.id) {
          const payload = {
            id: this.warehouse.id,
            warehouse: data,
          };
          try {
            await warehouseService.update(payload);
            this.$emit('hidden');
          } catch {
          }
        } else {
          try {
            await warehouseService.create(data);
            this.$emit('hidden');
          } catch {
          }
        }
        this.isSaving = false;
      }catch (e) {
        this.isSaving = false;
      }
    },
  },
}
</script>
